import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWORLD9 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "World News: Story 9",
            author: "footballgirl",
            date: "January 9, 2024",
            imageGradient: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
            content: `<p>This is the content for World News article #9.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`,
            navIndices: { prev: 'world-8', next: 'world-1' }
        });
    }

    init() {
        super.init();
    }
}